import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import { getCircular } from "../Service/Api";

const UKGAdmissions = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getAdmissionData = async () => {
      try {
        const res = await getCircular();

        // ✅ normalize response (in case API returns {data: [...] } or just [...] )
        const list = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
            ? res
            : [];

        // ✅ filter + sort
        const filteredSorted = list
          .filter((item) => item?.category === "Admission")
          .sort((a, b) => {
            const da = new Date(a?.date || 0).getTime();
            const db = new Date(b?.date || 0).getTime();
            return db - da; // descending
          });

        setData(filteredSorted);
      } catch (error) {
        console.error("Error fetching circular data", error);
        setData([]);
      }
    };

    getAdmissionData();
  }, []);

  useEffect(() => {
    document.title = "UKG Admissions -  The Air Force School Subroto Park";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Admissions </li>
          <li>Entry Level Admissions 2026-2027</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Entry Level Admissions 2026-2027 </h1>
            </div>
          </div>

          <div className="row">
            {data.map((item, idx) => {
              const hasAttachment =
                Array.isArray(item?.attachments) && item.attachments.length > 0;
              const href = hasAttachment
                ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                : "";

              return (
                <div className="col-lg-6" key={item?._id || idx}>
                  <div className="linktab">
                    {hasAttachment ? (
                      <Link to={href} target="_blank">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item?.title || "",
                          }}
                        />
                      </Link>
                    ) : (
                      <span
                        style={{ cursor: "default" }}
                        dangerouslySetInnerHTML={{
                          __html: item?.title || "",
                        }}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default UKGAdmissions;
